<template lang="pug">
block child
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    carouselItem() {
      const dataKey = this.item.message_type;
      return this.item[dataKey];
    },
  },
  methods: {
    selectItem() {
      this.$emit('selectItem', this.carouselItem);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
